import { getChatApiBaseUrl } from '../utils/chatApiBase.js';

// ─── Permission helpers ─────────────────────────────────────────────────────

export const getPermission = () => {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
};

export const requestPermission = async () => {
  if (!('Notification' in window)) return 'unsupported';
  if (Notification.permission !== 'default') return Notification.permission;
  return await Notification.requestPermission();
};

// ─── In-tab notification (works while browser tab is open) ─────────────────

export const showBrowserNotification = (title, options = {}) => {
  if (!('Notification' in window) || Notification.permission !== 'granted') return null;
  try {
    return new Notification(title, { icon: '/favicon.ico', ...options });
  } catch {
    return null;
  }
};

// ─── Service Worker ─────────────────────────────────────────────────────────

export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    console.log('[SW] Registered:', reg.scope);
    return reg;
  } catch (e) {
    console.warn('[SW] Registration failed:', e);
    return null;
  }
};

// ─── Web Push subscription ──────────────────────────────────────────────────

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

const chatApiBase = () => getChatApiBaseUrl();

/** Fetch VAPID public key from chat server */
async function getVapidPublicKey() {
  try {
    const res = await fetch(`${chatApiBase()}/push/vapid-key`);
    if (!res.ok) return null;
    const { publicKey } = await res.json();
    return publicKey;
  } catch {
    return null;
  }
}

/** Subscribe to Web Push and send subscription to server */
export async function setupPushSubscription() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
  if (Notification.permission !== 'granted') return;

  try {
    const reg = await navigator.serviceWorker.ready;
    const vapidKey = await getVapidPublicKey();
    if (!vapidKey) {
      console.warn('[Push] No VAPID key from server');
      return;
    }

    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }

    // Send subscription to chat server
    const { endpoint, keys } = subscription.toJSON();
    const token = localStorage.getItem('token');
    await fetch(`${chatApiBase()}/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ endpoint, p256dh: keys.p256dh, auth: keys.auth }),
    });

    console.log('[Push] Subscription saved on server');
  } catch (e) {
    console.warn('[Push] setupPushSubscription failed:', e);
  }
}
